import Shimmer from "@/components/Shimmer"

// eslint-disable-next-line react/display-name
export default () => {
  return <Shimmer width={4} height={2.25} />
}
